import React from 'react';
import PropTypes from 'prop-types';
import {getSliderStyle} from './Input.utils';

import style from '../style.module.scss';

const INPUT_TYPE_RANGE = 'range';

/**
 * Input
 *  - Type Range Input
 */
export function Input(props) {
  const onChange = (event) => {
    setValueOfFrame(event.target.valueAsNumber);
  };

  const setClassName = () => {
    let classList = [style.input];
    if (props.customThumb) {
      classList.push(style.customThumb);
      if (props.disabled) classList.push(style.customThumb_invalid);
    }
    return classList.join(' ');
  };

  const onKeyDown = (event) => {
    let currentFrameValue = event.target.valueAsNumber;
    props.keyboardStep
      ? setUpdatedValueOfFrame(event, currentFrameValue)
      : setValueOfFrame(currentFrameValue);
  };

  const setUpdatedValueOfFrame = (event, currentFrameValue) => {
    if (event.keyCode === 39) {
      setValueOfFrame((currentFrameValue += props.keyboardStep));
    } else if (event.keyCode === 37) {
      setValueOfFrame((currentFrameValue -= props.keyboardStep));
    }
    event.preventDefault();
  };

  const setValueOfFrame = (value) => {
    props.onChange(value);
  };
  return (
    <>
      <input
        id='rangeSlider'
        role='slider'
        min={props.min}
        max={props.max}
        step={props.step}
        value={props.value}
        onKeyDown={onKeyDown}
        onChange={onChange}
        type={INPUT_TYPE_RANGE}
        className={setClassName()}
        aria-valuemin={props.min}
        aria-valuemax={props.max}
        aria-valuenow={props.value}
        aria-valuetext={props.inputLabel}
        aria-labelledby={props.labelledby}
        style={getSliderStyle(props)}
        tabIndex={props.tabIndex}
      />
    </>
  );
}

Input.propTypes = {
  /**
   * min value
   */
  min: PropTypes.number,
  /**
   * max value
   */
  max: PropTypes.number,
  /**
   * current value
   */
  value: PropTypes.number,
  /**
   * The value of a step
   */
  step: PropTypes.number,
  /**
   * KeyboardStep is used to increase a fixed number of steps in arrow right and arrow left
   */
  keyboardStep: PropTypes.number,
  /**
   * Function to call on value change
   */
  onChange: PropTypes.func,
  /**
   * Boolean to set if Input should display a Custom Thumb
   */
  customThumb: PropTypes.bool,
  /**
   * Label for input(used as aria-label)
   */
  inputLabel: PropTypes.string,
  /**
   * colour for left part of the slider
   */
  leftPortionColour: PropTypes.string,
  /**
   * colour for right part of the slider
   */
  rightPortionColour: PropTypes.string,
  /**
   * specifies if it is keyboard accessible
   */
  tabIndex: PropTypes.number,
};

Input.defaultProps = {
  min: 0,
  max: 10,
  value: 1,
  step: 1,
  customThumb: true,
  autoFocus: true,
  inputLabel: 'aria-label',
};
